import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Mask from 'vanilla-masker'

import { uniqueIdentificationGenerator } from '../../utils/uniqueIdentificationGenerator'

import warningIcon from 'images/warning-icon.svg'
import errorIcon from 'images/error-icon.svg'
import successIcon from 'images/success-icon.svg'
import ClearSVG from 'component/svgComponents/clear'

class TextField extends Component {
  static propTypes = {
    /* The input placeholder */
    placeholder: PropTypes.string,

    /* The text that will be displayed along with the input */
    label: PropTypes.string,

    /* The input name */
    name: PropTypes.string,

    /* The input id */
    id: PropTypes.string,

    /* The text that will be displayed below the input */
    helpText: PropTypes.string,

    /* The text that will be displayed below the input when the input is valid */
    successText: PropTypes.string,

    /* The text that will be displayed below the input when an error is found */
    errorText: PropTypes.string,

    /* The text that will be displayed below the input when an warning need to be displayed */
    warningText: PropTypes.string,

    /* The element classes */
    className: PropTypes.string,

    /* Initial value */
    value: PropTypes.string,

    /* Callback for when the input changes */
    onChange: PropTypes.func,

    /* Callback for key down events */
    onKeyDown: PropTypes.func,

    /* Callback for when the user click on input */
    onClick: PropTypes.func,

    /* Determine if the input is or not required */
    required: PropTypes.bool,

    /* Determine if the input is or not disabled */
    disabled: PropTypes.bool,

    /* Determine if the input is or not readonly */
    readOnly: PropTypes.bool,

    /* Function that will be triggered when the value changes. May return true or false to wheter the new value is or not valid */
    validateValue: PropTypes.func,

    /* mask the input */
    mask: PropTypes.string,

    /* min input length */
    minLength: PropTypes.number,

    /* max input length */
    maxLength: PropTypes.number,

    /* input type */
    type: PropTypes.string,

    /* inputMode attribute, e.g. 'decimal', 'numeric' */
    inputMode: PropTypes.string,

    /* 100% width */
    fill: PropTypes.bool,

    /* A Glyph class name to be shown on the right side of the input */
    rightIcon: PropTypes.string,

    /* A callback for when the glyph is clicked */
    onRightIconClick: PropTypes.func,

    // Value of input fixed by parameter value
    controlledValue: PropTypes.string,

    // Determine if the value of input is write by user or controlled by variables
    isControlledValue: PropTypes.bool,

    readOnlyFocus: PropTypes.bool,
    
    clearIcon: PropTypes.bool,

    error:PropTypes.bool,

    errorMsg: PropTypes.string,

    notZero: PropTypes.bool,

    controlled: PropTypes.bool
,

    /* Static text shown inside input on the right side (visual only) */
    suffix: PropTypes.string
  }

  state = {
    /* The input value  */
    value: this.props.value || '',

    /* Stores the information of wheter the input is or not valid  */
    isValid: null,
  }

  componentDidUpdate(prevProps) {
    if (
      (this.props.value || this.props.value === '') &&
      this.props.value !== prevProps.value
    ) {
      this.setNewValue(this.props.value)
    }
  }

  setNewValue(value) {
    this.setState({ value, isValid: this.valueIsValid(value) })
  }

  getClasses() {
    const { disabled, readOnly, fill, controlledValue} = this.props
    const { isValid, value } = this.state
    return `
            ${disabled ? 'disabled' : ''}
            ${isValid === false ? 'invalid' : ''}
            ${isValid === true ? 'valid' : ''}
            ${readOnly ? 'read-only' : ''}
            ${fill ? 'full-width' : ''}
            ${value || controlledValue ? 'filled' : ''}
        `
  }

  onChange(e) {
    const { onChange, mask, notZero = false, controlled = false } = this.props
    if(notZero && e.target.value === "0" ) return
    if (mask) {
      e.target.value = Mask.toPattern(e.target.value, mask)
    }

    if(!controlled) {
      this.setState({
        value: e.target.value,
        isValid: this.valueIsValid(e.target.value),
      })
    }

    if (typeof onChange === 'function') {
      onChange(e)
    }
  }

  onClick(e) {
    const { onClick } = this.props

    if (typeof onClick === 'function') {
      onClick(e)
    }
  }

  valueIsValid(value) {
    const { required, validateValue } = this.props

    if (validateValue) {
      return validateValue(value)
    }
    return required && value === ''
  }

  textHelperDisplay() {
    const { errorText, warningText, helpText, successText, error = false, errorMsg } = this.props
    const { isValid } = this.state

    if (error && errorMsg) {
      return ['error', <img key='errorIcon' src={errorIcon} />, errorMsg];
    }

    if (isValid === true) {
      if (successText)
        return ['success', <img key='successIcon' src={successIcon} />, successText]
      if (helpText) return ['default', null, helpText]
    } else if (isValid !== false) {
      if (helpText) return ['default', null, helpText]
    } else {
      if (errorText) {
        return ['error', <img key='errorIcon' src={errorIcon} />, errorText]
      }

      if(error ) {
        return ['error', <img key='errorIcon' src={errorIcon} />, errorMsg]
      }
      if (warningText) {
        return ['warning', <img key='warningIcon' src={warningIcon} />, warningText]
      }
    }
    return ['', null, null]
  }

  render() {
    const {
      label,
      name,
      required,
      disabled,
      className,
      id,
      placeholder,
      minLength,
      maxLength,
      type,
      rightIcon,
      onRightIconClick,
      controlledValue,
      isControlledValue,
      readOnly,
      readOnlyFocus,
      clearIcon,
      onKeyDown,
      inputMode
      ,
      suffix
    } = this.props
    const { value } = this.state

    const customId = id || uniqueIdentificationGenerator('input-text_')
    const customName = name || uniqueIdentificationGenerator('input-text_')
    const classes = this.getClasses()
    const [inputValidationClass, inputSmallIcon, inputSmallText] =
      this.textHelperDisplay()

    return (
      <>
        <div
          onClick={() => readOnly && this.onClick("")}
          className={`input-container input-container-select ${inputValidationClass} ${classes} ${suffix ? 'has-suffix' : ''}`}
        >
          <label>
            {label}
            {required !== true && <i> - opcional</i>}
          </label>
          <input
            style={readOnlyFocus ? {borderColor: "#add585"} : (value || controlledValue) ? {borderColor: "#add585"} : {}}
            type={type || 'text'}
            id={customId}
            name={customName}
            disabled={disabled}
            required={required}
            className={className || 'form-control'}
            onChange={(e) => this.onChange(e)}
            onClick={(e) => this.onClick(e)}
            value={isControlledValue ? controlledValue : value}
            placeholder={placeholder}
            minLength={minLength}
            maxLength={maxLength}
            readOnly={readOnly}
            autoComplete={isControlledValue ? 'off' : 'on'}
            onKeyDown={onKeyDown}
            inputMode={inputMode}
          />

          {suffix && <span className="input-suffix">{suffix}</span>}

          {clearIcon && <ClearSVG onClick={onRightIconClick} className={`${value || controlledValue ? "attribute-input-right" : "hide-shadow"  }`}/> }
          {rightIcon && (
            <i
              className={`${
                value || controlledValue
                  ? `${rightIcon} right-icon`
                  : `${rightIcon} right-icon right-icon-inactive`
              }
                        `}
              onClick={onRightIconClick}
            />
          )}
          {inputSmallText && (
            <small className={inputValidationClass}>
              {inputSmallIcon}
              {inputSmallText}
            </small>
          )}
        </div>
      </>
    )
  }
}

export default TextField
